<script setup>
import CFIcon from '@/ui/Icon/CFIcon.vue';
</script>

<template>
    <div class="mt-4 flex items-start gap-2 py-4">
        <CFIcon
            name="file-text-search"
            class="size-6 text-black"
        />
        <div class="flex flex-col gap-1">
            <span class="font-bold">
                {{ $t('invoices.older_invoices_via_support') }}
            </span>
            <RouterLink
                :to="{ name: 'support' }"
                class="underline underline-offset-3"
            >
                {{ $t('invoices.contact_support') }}
            </RouterLink>
        </div>
    </div>
</template>
